<template>
	<p class="text-general text-padding-left">
		Elige una de tus direcciones, si no tienes alguna completa los datos del domicilio donde quieres recibir tu pedido.
	</p>
	<h2 v-if="render_billing_info.length">Mis Direcciones</h2>
    <div class="col-sm-3 pointer" v-for="billing_info in render_billing_info" v-if="!billing_info.rfc" @click="selectExistAddress(billing_info, billing_info.index, $event)">
		<div class="address-container">
			<p><strong>Dirección {{ $index + 1 }}</strong></p>
			<p class="text-general">
				{{ billing_info.street }} {{ billing_info.ext_number }}<br>
				{{ billing_info.suburb }}<br>
				{{ billing_info.city.nom_mun }}, {{ render_states[billing_info.city.ent_id - 1].nom_ent }}, {{ billing_info.postal_code }}<br>
				{{ billing_info.phone_number }}
			</p>
		</div>
	</div>
	<div class="col-sm-12">
		<h2>Nueva Dirección</h2>
		<form class="form-horizontal" role="form" @submit="nextStep">
			<div class="row no-margin">
				<div class="col-sm-6">
					<div class="form-group no-margin">
					    <label class="control-label col-sm-3" for="name">
					    	Nombre*
					    </label>
					    <div class="col-sm-9">
					        <input type="text" class="form-control" :class="{ 'has-error': err.first_name }" v-model="form.first_name" id="name">
					        <div class="tooltip-error" v-if="err.first_name">
						      	Ingresa tu nombre para continuar.
						    </div>
						    <div class="tooltip-error" v-if="err.first_name_msg">
						      	{{ err.first_name_msg }}
						    </div>
					    </div>
				 	</div>
				</div>
				<div class="col-sm-6">
					<div class="form-group">
						<label class="control-label col-sm-3" for="last-name">
							Apellidos*
						</label>
						<div class="col-sm-9">
							<input type="last-name" class="form-control" :class="{ 'has-error': err.last_name }" v-model="form.last_name" id="last-name">
							<div class="tooltip-error" v-if="err.last_name">
						      	Ingresa tu apellido para continuar.
						    </div>
						    <div class="tooltip-error" v-if="err.last_name_msg">
						      	{{ err.last_name_msg }}
						    </div>
						</div>
					</div>
				</div>
			</div>
			<div class="row no-margin">
				<div class="col-sm-6">
					<div class="form-group">
						<label class="control-label col-sm-3" for="street">
							Calle*
						</label>
						<div class="col-sm-9">
							<input type="text" class="form-control" :class="{ 'has-error': err.street }" v-model="form.street" id="street">
							<div class="tooltip-error" v-if="err.street">
						      	Ingresa tu calle para continuar.
						    </div>
						    <div class="tooltip-error" v-if="err.street_msg">
						      	{{ err.street_msg }}
						    </div>
						</div>
					</div>
				</div>
				<div class="col-sm-6">
					<div class="form-group">
						<label class="control-label col-sm-3" for="pwd">
							N° Ext.*
						</label>
						<div class="col-sm-3">
							<input type="text" class="form-control" id="pwd" :class="{ 'has-error': err.ext_number }" v-model="form.ext_number">
							<div class="tooltip-error" v-if="err.ext_number">
						      	Ingresa el número exterior de tu domicilio para continuar.
						    </div>
						    <div class="tooltip-error" v-if="err.ext_number_msg">
						      	{{ err.ext_number_msg }}
						    </div>
						</div>
						<label class="control-label col-sm-3" for="pwd">
							N° Int.
						</label>
						<div class="col-sm-3">
							<input type="text" class="form-control" id="pwd" :class="{ 'has-error': err.int_number }" v-model="form.int_number">
						</div>
					</div>
				</div>
			</div>
			<div class="row no-margin">
				<div class="col-sm-6">
					<div class="form-group">
						<label class="control-label col-sm-3" for="suburb">
							Colonia*
						</label>
						<div class="col-sm-9">
							<input type="text" class="form-control" id="suburb" :class="{ 'has-error': err.suburb }" v-model="form.suburb">
							<div class="tooltip-error" v-if="err.suburb">
						      	Ingresa el nombre de la colonia para continuar.
						    </div>
						    <div class="tooltip-error" v-if="err.suburb_msg">
						      	{{ err.suburb }}
						    </div>
						</div>
					</div>
				</div>
				<div class="col-sm-6">
					<div class="form-group">
						<label class="control-label col-sm-3" for="pwd">
							C.P.*
						</label>
						<div class="col-sm-9">
							<input type="text" class="form-control" id="pwd" :class="{ 'has-error': err.postal_code }" v-model="form.postal_code">
							<div class="tooltip-error" v-if="err.postal_code">
						      	Ingresa el código postal de tu domicilio para continuar.
						    </div>
						    <div class="tooltip-error" v-if="err.postal_code_msg">
						      	{{ err.postal_code_msg }}
						    </div>
						</div>
					</div>
				</div>
			</div>
			<div class="row no-margin">
				<div class="col-sm-6">
					<div class="form-group">
						<label class="control-label col-sm-3" for="city">
							Estado*
						</label>
						<div class="col-sm-9">
							<div class="form-control control-select">
							    <select class="select" :class="{ 'has-error': err.state }" v-model="form.state" @change="addCities(form.state)">
									<option value="" disabled selected>Selecciona un estado</option>
									<option v-for="state in render_states" :value="state.id">{{ state.nom_ent }}</option>
								</select>
								<i class="fa fa-caret-down select-caret"></i>
							</div>
							<div class="tooltip-error" v-if="err.state">
						      	Ingresa tu estado para continuar.
						    </div>
						</div>
					</div>
				</div>
				<div class="col-sm-6">
					<div class="form-group">
						<label class="control-label col-sm-3" for="state">
							Ciudad*
						</label>
						<div class="col-sm-9">
							<div class="form-control control-select">
								<select class="select" :class="{ 'has-error': err.city }" v-model="form.city" id="city">
								  	<option value="" disabled selected>Seleccionar primero un estado</option>
								  	<option v-for="city in render_cities" :value="city.id">{{ city.nom_mun }}</option>
								</select>
								<i class="fa fa-caret-down select-caret"></i>
							</div>
						  <div class="tooltip-error" v-if="err.city">
					      	Ingresa tu ciudad para continuar.
					      </div>
						</div>
					</div>
				</div>
			</div>
			<div class="row no-margin">
				<div class="col-sm-6">
					<div class="form-group">
						<label class="control-label col-sm-3" for="city">
							Télefono*
						</label>
						<div class="col-sm-9">
							<input type="text" class="form-control" id="city" :class="{ 'has-error': err.phone_number }" v-model="form.phone_number">
							<div class="tooltip-error" v-if="err.phone_number">
						      	Ingresa tu número de teléfono para continuar.
						    </div>
						    <div class="tooltip-error" v-if="err.phone_number_msg">
						      	{{ err.phone_number_msg }}
						    </div>
						</div>
					</div>
				</div>
				<!-- <div class="col-sm-6">
					<div class="form-group">
						<label class="control-label col-sm-3" for="state">
							Pais*
						</label>
						<div class="col-sm-9">
						  <input type="text" class="form-control" id="state" :class="{ 'has-error': err.country }" v-model="form.country">
						</div>
					</div>
				</div> -->
			</div>
			<div class="row no-margin">
				<div class="col-sm-6 col-sm-offset-6">
					<div class="col-sm-9" style="float:right;">
						<button type="submit" class="btn btn-black btn-lg">Siguiente</button>
					</div>
				</div>
			</div>
	    </form>
	</div>

</template>

<script>
import { toast } from '../../scripts/toast';
import {
	setAddressShoppingCart,
	addBillingInfo,
	addCities,
	setFedexQuote,
	setNationalQuote,
	setShoppingCartIndex,
	resetFedexQuote,
	resetNationalQuote
} from '../../store/actions';

var string_regexp = new RegExp(/^[a-zA-Z0-9á-úÁ-Ú_ ]*$/);
var phone_regexp = new RegExp(/^\d{10}$/);
var postal_code_regexp = new RegExp(/^\d{5}$/);
var number_regexp = new RegExp(/^\d/);
var alphanumeric_regexp = new RegExp(/[^\s#°]+(\s+[^\s]+)*$/);

export default {
	data() {
		return {
			form: {
				first_name: '',
				street: '',
				suburb: '',
				city: '',
				last_name: '',
				int_number: '',
				ext_number: '',
				state: '',
				postal_code: '',
				// country: '',
				phone_number: ''
			},
			has_error: false,
			error_msg: '',
			err: {}
		}
	},

	vuex: {
		getters: {
			user: state => state.current_user,
			states: state => state.states,
			cities: state => state.cities,
			allow_continue: state => state.allow_continue,
			products: state => state.shopping_cart.products,
			billing_infos: state => state.billing_info,
			billing_info: state => {
				let billings = [];

				for (let i = 0, b = state.billing_info; i < b.length; i++) {
					b[i].index = i;

					if (!b[i].rfc) {
						billings.push(b[i]);
					}
				}

				return billings;
			}
		},
		actions: {
			setAddressShoppingCart,
			addBillingInfo,
			addCities,
			setFedexQuote,
			setNationalQuote,
			setShoppingCartIndex,
			resetFedexQuote,
			resetNationalQuote
		}
	},

	computed: {
		render_states() {
			return this.states;
		},

		render_cities() {
			return this.cities;
		},

		render_billing_info() {
			return this.billing_info;
		}
	},

	methods: {
		nextStep(e) {
			e.preventDefault();
			let index = 0;
			let is_fedex_able = 0;
			let quote_fedex = 0;
			let quote_national = 1;
			this.has_error = false;
			this.error_msg = null;
			this.err = {};
			this.validations();

			// Fix the tooltip for xs and sm screens.
			setTimeout( function(){
				$(".tooltip-error").css({"position": "initial", "margin-top" : "20px"});
				$(".tooltip-error").addClass("center-block");
			}, 10);

			if (this.billing_infos.length) {
				index = this.billing_infos.length;
			} else {
				index = 0;
			}

			if (this.has_error) {
				return;
			}
			// get if the product is fedex able.
			is_fedex_able = this.isFedexAble(this.products);

			// Old version of set index.
			// if (!this.billing_info.length) {
			// 	index = 0;
			// } else {
			// 	index = this.billing_info.length;
			// }

			// get the fedex quote.
			if (is_fedex_able) {
				quote_fedex = 1;
			}
			/* Add billing info.
			@param: user [object]
			@param: form [object]
			@param: with_quote [object] to indentify if is needed to
			send a request to make a quote. */
			this.addBillingInfo(this.user, this.form, {
				quote_fedex: quote_fedex,
				quote_national: quote_national,
				index: index,
				product_id: this.products[0].product_id
			});
			// this.resetFedexQuote();
			// this.resetNationalQuote();
      // this.setFedexQuote(this.user, index, this.products[0].product_id);
			this.setShoppingCartIndex(index);
			// Set the current billing info from add billing info action.
      this.setAddressShoppingCart(this.form);
			this.allow_continue[3] = true;
			$('#payment').tab('show');
		},

		selectExistAddress(info, index, e) {
			let is_fedex_able = 0;
			let $target = $(e.target);
			// get if the product is fedex able.
			is_fedex_able = this.isFedexAble(this.products);

			// get the fedex quote.
			// if (is_fedex_able && !info.is_metroZone) {
			// 	this.setFedexQuote(this.user, index, this.products[0].product_id);
      // }

			// get the national quote.
			// if (!info.is_metroZone) {
			// 	this.setNationalQuote(this.user, index);
      // }

      this.setNationalQuote(this.user, index);
			// set the active address and reset the others.
			$('.address-container').removeClass('address-active');

			if ($target.hasClass('address-container')) {
				$target.addClass('address-active');
			} else {
				$target.parent().addClass('address-active');
			}
			// $(e.target).addClass('address-active');

			// this.resetFedexQuote();
			// this.resetNationalQuote();
			this.setShoppingCartIndex(index);
      this.setAddressShoppingCart(info);
			this.allow_continue[3] = true;
			$('#payment').tab('show');

			toast({
				title: 'Direcciones',
				content: 'Has seleccionado la dirección a donde se mandara tu pedido.'
			});
		},

		isFedexAble(products) {
			for (let i = 0, p = products; i < p.length; i++) {
				if (p[i].product.fedex_able == 0) {
					return 0;
				}
			}

			return 1;
		},

		validations() {
			for (var k in this.form) {
				if (!this.form[k] && k != 'int_number') {
					this.err[k] = true;
					this.has_error = true;
				}
			}

			/*if (this.form.phone_number && this.form.phone_number.length < 10) {
				this.err.phone_number = true;
				this.has_error = true;
				this.error_msg = 'El telefono debe tener 10 digitos';
			}*/
			if(!this.form.phone_number){
				this.err.phone_number = true;
				this.has_error = true;
			}

			if (!this.form.phone_number.match(phone_regexp) && !this.err.phone_number) {
				this.has_error = true;
				this.err.phone_number_msg = 'Ingresa tu número a 10 dígitos para continuar.';
			}

			if(!this.form.city){
				this.err.city = true;
				this.has_error = true;
				this.msg_error = 'Ingresa una ciudad para continuar';
			}

			if(!this.form.state){
				this.err.state = true;
				this.has_error = true;
				this.msg_error = 'Ingresa un estado para continuar';
			}

			if(!this.form.postal_code){
				this.err.postal_code = true;
				this.has_error = true;
			}

			if (!this.form.postal_code.match(postal_code_regexp) && !this.err.postal_code) {
				this.has_error = true;
				this.err.postal_code_msg = 'Ingresa un código postal válido para continuar.';
			}

			//validate only regexp, because int can be empty
			if (!this.form.int_number.match(number_regexp) && this.form.int_number) {
				this.has_error = true;
				this.err.int_number_msg = 'Ingresa solamente números para continuar.';
			}

			if(!this.form.suburb){
				this.err.suburb = true;
				this.has_error = true;
			}

			if (!this.form.suburb.match(string_regexp) && !this.err.suburb) {
				this.has_error = true;
				this.err.suburb_msg = 'Ingresa solamente letras para continuar.';
			}

			if(!this.form.ext_number){
				this.has_error = true;
				this.err.ext_number = true;
			}

			if (!this.form.ext_number.match(number_regexp) && !this.err.ext_number) {
				this.has_error = true;
				this.err.ext_number_msg = 'Ingresa solamente números para continuar.';
			}

			if(!this.form.street){
				this.err.street = true;
				this.has_error = true;
			}

			if (!this.form.street.match(alphanumeric_regexp) && !this.err.street) {
				this.has_error = true;
				this.err.street_msg = 'Ingresa solamente letras para continuar.';
			}

			if(!this.form.last_name){
				this.err.last_name = true;
				this.has_error = true;
			}

			if (!this.form.last_name.match(string_regexp) && !this.err.last_name ) {
				this.has_error = true;
				this.err.last_name_msg = 'Ingresa solamente letras para continuar.';
			}

			if(!this.form.first_name){
				this.err.first_name = true;
				this.has_error = true;
			}

			if (!this.form.first_name.match(string_regexp) && !this.err.first_name ) {
				this.has_error = true;
				this.err.first_name_msg = 'Ingresa solamente letras para continuar.';
			}
		}
	},

	ready() {
		this.resetFedexQuote();
	}
}
</script>

<style scoped>
	.form-horizontal .form-group{
		margin: 0;
	}
	.custom-checkbox{
		margin-left: 30px;
	}
	form .row{
		padding: 10px;
	}
	form .form-control.has-error {
		border: solid 1px red;
	}

	.pointer {
		cursor: pointer;
	}

	label{
		font-family: "Raleway";
		font-size: 11.5px;
		color: #9b9b9b;
	}

	.padding-left-xs{
		padding-left: 5px;
	}

	@media(max-width: 768px){
		.radio-container{
			margin-left: 20px;
		}

	}
</style>



// WEBPACK FOOTER //
// Shopping-cart-address.vue?6bef7359